<mprd-flex-product-card-skeleton *ngIf="isLoading"></mprd-flex-product-card-skeleton>

<div class="rs-panel-flex" *ngIf="!isLoading">
  <div class="rs-panel-flex-cell rs-bg-grey2 clearfix">
    <div class="rs-flex-row rs-flex-middle-small-only">
      <div class="rs-flex-column rs-flex-shrink">
        <i
          class="icon-Smartphone icon-lh rs-txt-primary rs-txt-s7 rs-margin-bottom2"
          aria-hidden="true"
        ></i>
      </div>
      <div class="rs-flex-column">
        <h2 class="rs-tit6 rs-padding-bottom2">
          <mprd-access-number-formatter
            [accessNumber]="this.product.accessNumber"
            [plc]="this.product.plc"
          ></mprd-access-number-formatter>
        </h2>
      </div>
      <div class="rs-flex-column rs-flex-shrink">
        <ng-container *ngIf="isActive; else displayActivateButton">
          <p class="rs-status rs-status-ok">
            <i class="rs-status-icon" aria-hidden="true"></i
            >{{ 'flexEmergency.manage.activeLabel' | translate }}
          </p>
        </ng-container>
        <ng-template #displayActivateButton>
          <button
            data-tms-event="button-click"
            data-tms-button-zone="flex-emergency-manage"
            data-tms-button-name="activate"
            href="javascript:void(0)"
            [ngClass]="class"
            (click)="activateProduct()"
          >
            {{ 'flexEmergency.manage.activateLabel' | translate
            }}<span class="show-for-sr">{{ phoneNumber }}</span>
          </button>
        </ng-template>
      </div>
    </div>
    <ng-container *ngIf="hasError; else Active"
      ><px-alert [alerts]="alerts" *ngIf="alerts.length > 0"></px-alert
    ></ng-container>
    <ng-template #Active>
      <ng-container *ngIf="isActive; else notActive">
        <div class="rs-usage-progress">
          <div class="rs-usage-progress-title">
            {{ 'flexEmergency.manage.timeLeft' | translate }}
          </div>
          <div
            class="rs-usage-progress-bar"
            role="progressbar"
            [attr.aria-valuenow]="this.timeRemaining.percentageUsed * 100"
            [attr.aria-valuemin]="0"
            [attr.aria-valuemax]="100"
          >
            <span
              [ngClass]="'rs-usage-progress-bar-meter jsrs-progressbar'"
              [style.width.%]="this.timeRemaining.percentageUsed * 100"
            ></span>
          </div>
          <span class="rs-usage-progress-used"
            >{{ this.timeRemaining.leftHours + ' ' }}
            {{ 'flexEmergency.manage.hoursLabel' | translate }}</span
          >
          <span class="rs-usage-progress-amount">
            {{ getTimeLeftTranslation() }}
          </span>
        </div>
        <ng-container *ngIf="showSessionsSection">
          <h3 class="rs-tit6">{{ 'flexEmergency.manage.sessionLabel' | translate }}</h3>
          <div class="panel rs-bg-grey2">
            <div
              class="rs-flex-row"
              *ngIf="
                !!product.emergencyInternetSessionValidity && !!product.emergencyInternetSessionLeft
              "
            >
              <div class="rs-flex-column">
                <p class="rs-txt-details rs-padding-bottom1">
                  {{ 'flexEmergency.manage.sessionUntil' | translate }}
                  <mprd-date-formatter
                    [date]="this.product.emergencyInternetSessionValidity"
                    [selectedFormat]="'DD/MM/YYYY'"
                  ></mprd-date-formatter>
                </p>
              </div>
              <div class="rs-flex-column rs-flex-shrink">
                <p class="rs-padding-bottom1">
                  {{ product.emergencyInternetSessionLeft }}
                  {{ 'flexEmergency.manage.leftLabel' | translate }}
                </p>
              </div>
            </div>
            <div class="rs-flex-row" *ngIf="!!product.emergencyInternetSessionUsed">
              <div class="rs-flex-column">
                <p class="rs-txt-details rs-padding-bottom1">
                  {{ 'flexEmergency.manage.usedSession' | translate }}
                </p>
              </div>
              <div class="rs-flex-column rs-flex-shrink">
                <p class="rs-padding-bottom1">
                  {{ product.emergencyInternetSessionUsed }}
                  {{ 'flexEmergency.manage.usedLabel' | translate }}
                </p>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </ng-template>
    <ng-template #notActive>
      <ng-container *ngIf="showSessionsSection">
        <h3 class="rs-tit6">{{ 'flexEmergency.manage.sessionLabel' | translate }}</h3>
        <div class="panel rs-bg-grey2">
          <div
            class="rs-flex-row"
            *ngIf="
              !!product.emergencyInternetSessionValidity && !!product.emergencyInternetSessionLeft
            "
          >
            <div class="rs-flex-column">
              <p class="rs-txt-details rs-padding-bottom1">
                {{ 'flexEmergency.manage.sessionUntil' | translate }}
                <mprd-date-formatter
                  [date]="this.product.emergencyInternetSessionValidity"
                  [selectedFormat]="'DD/MM/YYYY'"
                ></mprd-date-formatter>
              </p>
            </div>
            <div class="rs-flex-column rs-flex-shrink">
              <p class="rs-padding-bottom1">
                {{ product.emergencyInternetSessionLeft }}
                {{ 'flexEmergency.manage.leftLabel' | translate }}
              </p>
            </div>
          </div>
          <div class="rs-flex-row" *ngIf="!!product.emergencyInternetSessionUsed">
            <div class="rs-flex-column">
              <p class="rs-txt-details rs-padding-bottom1">
                {{ 'flexEmergency.manage.usedSession' | translate }}
              </p>
            </div>
            <div class="rs-flex-column rs-flex-shrink">
              <p class="rs-padding-bottom1">
                {{ product.emergencyInternetSessionUsed }}
                {{ 'flexEmergency.manage.usedLabel' | translate }}
              </p>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-template>
  </div>
</div>
